import { io } from 'socket.io-client';
import { BASE_URL_SOCKET } from './BaseUrl';

export const socket = io(`${BASE_URL_SOCKET}`, {
  transports: ['websocket', 'polling'],
});